"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./DynamicTable.css");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mobxReact = require("mobx-react");

var _LoadingStates = _interopRequireDefault(require("../../../shared/models/table/LoadingStates"));

var _classnames = _interopRequireDefault(require("classnames"));

var _map = _interopRequireDefault(require("lodash/map"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _noop = _interopRequireDefault(require("lodash/noop"));

var _Propulator = _interopRequireDefault(require("../../../higher-order/Propulator"));

var _Pagination = _interopRequireDefault(require("../../../components/common/Pagination"));

var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));

var _min = _interopRequireDefault(require("lodash/min"));

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

var _find = _interopRequireDefault(require("lodash/find"));

var _SearchableText = _interopRequireDefault(require("../../../components/tables/SearchableText"));

var _constants = require("../../../util/constants");

var _LoadSpinner = require("../../../shared/components/message/LoadSpinner");

var _class, _class2, _class3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

var DynamicTable = (0, _mobxReact.observer)(_class = (_class2 = (_class3 = /*#__PURE__*/function (_React$Component) {
  _inherits(DynamicTable, _React$Component);

  var _super = _createSuper(DynamicTable);

  function DynamicTable() {
    _classCallCheck(this, DynamicTable);

    return _super.apply(this, arguments);
  }

  _createClass(DynamicTable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.model.onMount(this.props.dispatcher);
    }
  }, {
    key: "handlePageClick",
    value: function handlePageClick(e) {
      this.props.model.changePage(e.selected);
    }
  }, {
    key: "handlePageSizeSelect",
    value: function handlePageSizeSelect(e) {
      this.props.model.updateItemsPerPage(e.target.value, this.props.dispatcher);
    }
  }, {
    key: "handleColumnSortClick",
    value: function handleColumnSortClick(columnDefinition, e) {
      e.preventDefault();
      this.props.model.updateSort(columnDefinition.sourceName, this.props.dispatcher);
    }
  }, {
    key: "renderTableHeader",
    value: function renderTableHeader() {
      var _this = this;

      var columnOptions = this.props.model.columnOptions;
      return (0, _map.default)(columnOptions, function (column, index) {
        // hack: porting old hidden column functionality
        if (column.hidden) {
          return null;
        }

        var cellClasses = {
          "table-header-cell": true,
          sortable: column.sortable,
          "column-hidden": _this.props.model.recordCount === 0
        };
        cellClasses[column.sourceName] = true;
        var handleSort = column.sortable ? _this.handleColumnSortClick.bind(_this, column) : null;
        var currentSortDefinition = (0, _find.default)(_this.props.model.sorts, function (sort) {
          return sort.iteratee === column.sourceName;
        });
        var isSorted = !(0, _isUndefined.default)(currentSortDefinition);
        var isPrimary = isSorted && currentSortDefinition.primary;
        var isDescending = isSorted && currentSortDefinition.descending;
        var sortIconClasses = {
          "icon-up-dir": isPrimary && isDescending,
          "icon-down-dir": isPrimary && !isDescending,
          "icon-down-dir on-hover": !isPrimary
        };
        return /*#__PURE__*/_react.default.createElement("div", {
          key: "column-header-".concat(index),
          role: "button",
          tabIndex: index,
          onKeyUp: handleSort,
          className: (0, _classnames.default)(cellClasses),
          onClick: handleSort
        }, /*#__PURE__*/_react.default.createElement("span", {
          title: column.displayTitle
        }, !(0, _isUndefined.default)(column.displayName) ? column.displayName : column.sourceName), column.sortable && /*#__PURE__*/_react.default.createElement("i", {
          className: (0, _classnames.default)(sortIconClasses)
        }));
      });
    }
  }, {
    key: "renderTableRows",
    value: function renderTableRows() {
      var _this2 = this;

      var tableData = this.props.model.currentData || [];
      var rowOptions = this.props.model.rowOptions || {};

      if (tableData.length === 0 && this.props.model.loadState === _LoadingStates.default.DATA_LOADED) {
        return this.renderEmptyTable();
      }

      return (0, _map.default)(tableData, function (rowModel, index) {
        var rowData = rowModel.data;
        var key = (0, _isFunction.default)(rowOptions.keyGetter) ? rowOptions.keyGetter(rowData) : "row-".concat(index);
        var rowClasses = ["table-row", (0, _isFunction.default)(rowOptions.classNameFormatter) ? rowOptions.classNameFormatter(rowData) : ""];
        var clickHandler = (0, _isFunction.default)(rowOptions.onRowClick) ? rowOptions.onRowClick.bind(_this2, rowData) : _noop.default;
        return /*#__PURE__*/_react.default.createElement("div", {
          key: key,
          className: (0, _classnames.default)(rowClasses),
          role: "link",
          tabIndex: index,
          onKeyUp: clickHandler,
          onClick: clickHandler
        }, _this2.renderSingleRow(rowModel, index, key));
      });
    }
  }, {
    key: "renderSingleRow",
    value: function renderSingleRow(rowModel, index, rowKey) {
      var data = rowModel.data;
      var columnOptions = this.props.model.columnOptions;
      var searchValue = this.props.model.searchFilter && this.props.model.searchFilter.searchValue ? this.props.model.searchFilter.searchValue : null;
      return (0, _map.default)(columnOptions, function (column) {
        var dataElement = !(0, _isUndefined.default)(data.get(column.sourceName)) ? data.get(column.sourceName) : null; // hack: porting old hidden column functionality

        if (column.hidden && !rowModel.toggledColumns.get(column.sourceName)) {
          return null;
        }

        var content = "";

        if ((0, _isFunction.default)(column.formatter)) {
          content = column.formatter(dataElement, data, index, searchValue);
        } else if (column.searchable) {
          content = /*#__PURE__*/_react.default.createElement(_SearchableText.default, {
            query: searchValue,
            text: dataElement.toString(),
            className: "searchable-cell"
          });
        } else {
          content = dataElement;
        }

        var cellClasses = (0, _classnames.default)(["table-row-cell", column.sourceName, {
          "no-mouseflow": column.noMouseflow
        }]);
        return /*#__PURE__*/_react.default.createElement("div", {
          key: "".concat(rowKey, "-value-").concat(column.sourceName),
          className: cellClasses
        }, content);
      });
    }
  }, {
    key: "renderEmptyTable",
    value: function renderEmptyTable() {
      var emptyTableFormatter = this.props.model.emptyTableFormatter;

      if ((0, _isFunction.default)(emptyTableFormatter)) {
        return emptyTableFormatter();
      }

      var rowClasses = (0, _classnames.default)(["table-row", "no-results-row"]);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: rowClasses
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "no-results-cell"
      }, "No results found."));
    }
  }, {
    key: "renderPagination",
    value: function renderPagination() {
      var numberOfPages = this.props.model.pageCount;

      if (numberOfPages > 1) {
        return /*#__PURE__*/_react.default.createElement(_Pagination.default, {
          previousLabel: "prev",
          nextLabel: "next",
          pageCount: numberOfPages,
          marginPagesDisplayed: 1,
          forcePage: this.props.model.currentPage || 0,
          pageRangeDisplayed: 4,
          onPageChange: this.handlePageClick,
          containerClassName: "pagination",
          subContainerClassName: "pages pagination",
          pageClassName: "page",
          previousClassName: "page",
          nextClassName: "page"
        });
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "empty-pagination"
      });
    }
  }, {
    key: "renderPageSizeSelect",
    value: function renderPageSizeSelect() {
      var pageSizeOptions = _constants.TABLE_PAGE_SIZES;

      if (!this.props.showItemsPerPage || this.props.model.recordCount <= (0, _min.default)(pageSizeOptions)) {
        return null;
      }

      var pageSize = this.props.model.itemsPerPage;
      var selectClasses = (0, _classnames.default)(["pagination-size-select", {
        "empty-pagination": this.props.model.recordCount <= pageSize
      }]);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: selectClasses
      }, /*#__PURE__*/_react.default.createElement("select", {
        onChange: this.handlePageSizeSelect,
        value: pageSize
      }, (0, _map.default)(pageSizeOptions, function (option) {
        return /*#__PURE__*/_react.default.createElement("option", {
          key: option,
          value: option
        }, option);
      })), /*#__PURE__*/_react.default.createElement("span", null, " per page"));
    }
  }, {
    key: "render",
    value: function render() {
      var model = this.props.model;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)("custom-div-table", this.props.className)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "table-header"
      }, this.renderTableHeader()), /*#__PURE__*/_react.default.createElement("div", {
        className: "table-body"
      }, !model.isLoaded && /*#__PURE__*/_react.default.createElement("div", {
        className: "loading-overlay"
      }, /*#__PURE__*/_react.default.createElement(_LoadSpinner.LoadingSpinner, null)), model.isLoaded && this.renderTableRows()), this.props.showDefaultPagination && /*#__PURE__*/_react.default.createElement("div", {
        className: "pagination-container"
      }, this.renderPagination(), this.renderPageSizeSelect()));
    }
  }]);

  return DynamicTable;
}(_react.default.Component), _defineProperty(_class3, "propTypes", {
  model: _propTypes.default.object.isRequired,
  showItemsPerPage: _propTypes.default.bool,
  className: _propTypes.default.string,
  dispatcher: _propTypes.default.object,
  showDefaultPagination: _propTypes.default.bool
}), _defineProperty(_class3, "defaultProps", {
  showItemsPerPage: false,
  showDefaultPagination: true
}), _class3), (_applyDecoratedDescriptor(_class2.prototype, "handlePageClick", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class2.prototype, "handlePageClick"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "handlePageSizeSelect", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class2.prototype, "handlePageSizeSelect"), _class2.prototype)), _class2)) || _class;

var _default = (0, _Propulator.default)(DynamicTable);

exports.default = _default;